var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "subpage-dashboards subpage-report--dashboard subpage-dashboards--left-spacer"
    },
    [
      _vm.billingStats
        ? _c(
            "section",
            {
              staticClass: "my-account__full-width-section gds-space-stack-xl"
            },
            [
              _c(
                "h2",
                {
                  staticClass: "gds-display-1 gds-space-stack-l",
                  attrs: { id: "yearly-totals" }
                },
                [_vm._v("Yearly Totals")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "my-account-billing-report__row gds-flex-container gds-flex-container--left"
                },
                [
                  _c(
                    "div",
                    { staticClass: "my-account-billing-report__col3" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "my-account-billing-report__data-label",
                          attrs: { id: "current-year-bills" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.billingStats.thisYear.year) + " Bills"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "my-account-billing-report__large-data",
                          attrs: {
                            "aria-labelledby":
                              "yearly-totals current-year-bills"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("currency")(
                                _vm.billingStats.thisYear.billTotal,
                                true
                              )
                            )
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "my-account-billing-report__col3" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "my-account-billing-report__data-label",
                          attrs: { id: "current-year-payments" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.billingStats.thisYear.year) + " Payments"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "my-account-billing-report__large-data",
                          attrs: {
                            "aria-labelledby":
                              "yearly-totals current-year-payments"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("currency")(
                                _vm.billingStats.thisYear.paymentTotal,
                                true
                              )
                            )
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "my-account-billing-report__col3" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "my-account-billing-report__data-label",
                          attrs: { id: "previous-year-bills" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.billingStats.lastYear.year) + " Bills"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "my-account-billing-report__large-data",
                          attrs: {
                            "aria-labelledby":
                              "yearly-totals previous-year-bills"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("currency")(
                                _vm.billingStats.lastYear.billTotal,
                                true
                              )
                            )
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "my-account-billing-report__col3" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "my-account-billing-report__data-label",
                          attrs: { id: "previous-year-payments" }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.billingStats.lastYear.year) + " Payments"
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "my-account-billing-report__large-data",
                          attrs: {
                            "aria-labelledby":
                              "yearly-totals previous-year-payments"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("currency")(
                                _vm.billingStats.lastYear.paymentTotal,
                                true
                              )
                            )
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.billingStats
        ? _c(
            "section",
            {
              staticClass: "my-account__full-width-section gds-space-stack-xl"
            },
            [
              _c(
                "h2",
                {
                  staticClass: "gds-display-1 gds-space-stack-l",
                  attrs: { id: "seasonal-averages" }
                },
                [_vm._v("Seasonal Averages")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "my-account-billing-report__row gds-flex-container gds-flex-container--left"
                },
                [
                  _c(
                    "div",
                    { staticClass: "my-account-billing-report__col3" },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "my-account-billing-report__large-data",
                          attrs: {
                            "aria-labelledby": "seasonal-averages winter-avg"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("currency")(
                                _vm.billingStats.winterAverage,
                                true
                              )
                            )
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "my-account-billing-report__col3" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "my-account-billing-report__large-data",
                          attrs: {
                            "aria-labelledby": "seasonal-averages spring-avg"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("currency")(
                                _vm.billingStats.springAverage,
                                true
                              )
                            )
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "my-account-billing-report__col3" },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "my-account-billing-report__large-data",
                          attrs: {
                            "aria-labelledby": "seasonal-averages summer-avg"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("currency")(
                                _vm.billingStats.summerAverage,
                                true
                              )
                            )
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "my-account-billing-report__col3" },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "my-account-billing-report__large-data",
                          attrs: {
                            "aria-labelledby": "seasonal-averages fall-avg"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("currency")(
                                _vm.billingStats.fallAverage,
                                true
                              )
                            )
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "my-account__full-width-section gds-space-stack-xl" },
        [
          _c("h2", { staticClass: "gds-display-1 gds-space-stack-l" }, [
            _vm._v("Detailed Report")
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "my-account-billing-report__data-tables-wrapper" },
            [
              _c("p", [
                _vm._v(
                  "View and customize a spreadsheet of all bill charges, quantities, and rates for the dates you choose. The detailed report will open in a new window."
                )
              ]),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "gds-button gds-round gds-space-stack-l",
                  attrs: {
                    href:
                      _vm.EnvironmentConstants.BillReportURL +
                      "/?accountNumber=" +
                      _vm.currentAccount.accountNumber,
                    target: "_blank"
                  }
                },
                [_vm._v("Launch Detailed Report")]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "my-account-billing-report__data-label",
        attrs: { id: "winter-avg" }
      },
      [
        _vm._v("\n          Winter\n          "),
        _c("span", { staticClass: "gds-font-book" }, [
          _vm._v("(Dec, Jan, Feb)")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "my-account-billing-report__data-label",
        attrs: { id: "spring-avg" }
      },
      [
        _vm._v("\n          Spring\n          "),
        _c("span", { staticClass: "gds-font-book" }, [
          _vm._v("(Mar, Apr, May)")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "my-account-billing-report__data-label",
        attrs: { id: "summer-avg" }
      },
      [
        _vm._v("\n          Summer\n          "),
        _c("span", { staticClass: "gds-font-book" }, [
          _vm._v("(Jun, July, Aug)")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "my-account-billing-report__data-label",
        attrs: { id: "fall-avg" }
      },
      [
        _vm._v("\n          Fall\n          "),
        _c("span", { staticClass: "gds-font-book" }, [
          _vm._v("(Sept, Oct, Nov)")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }